const styles = (theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
	},
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "16px",
		borderRadius: "22px",
		position: "relative",
		width: "450px",
		padding: "20px",
		maxWidth: "80vw",
		background: theme.palette.secondary.darker,
	},
	title: {
		marginTop: "8px",
		color: theme.palette.white.main,
		fontSize: "1.5rem",
		fontWeight: "bold",
		textAlign: "center",
	},
	iconButton: {
		position: "absolute",
		right: 16,
		top: 16,
		color: theme.palette.white.main,
		padding: 0,
	},
	avatar: {
		transform: "translateX(-50%)",
		position: "absolute",
		left: 85,
		top: 25,
		height: "90px",
		width: "90px",
		border: "4px solid",
		borderColor: theme.palette.secondary.darker,
		color: theme.palette.white.main,
		background:
			theme.palette.mode == "dark"
				? theme.palette.colors.gray.dark
				: theme.palette.black.light,
		"@media (max-width: 500px)": {
			display: "none",
		},
	},
	content: {
		background: theme.palette.background.modalContrast,
		display: "flex",
		flexDirection: "column",
		padding: {
			xs: "10px",
			sm: "20px",
		},
		gap: "16px",
		width: "100%",
		borderRadius: "20px",
	},
	buttonSave: {
		background: theme.palette.primary.main,
		borderRadius: "10px",
		height: "40px",
		ml: 2,
	},
	buttonCancelar: {
		color: theme.palette.text.main,
		borderRadius: "10px",
		height: "40px",
	},
	TextField: {
		width: "100%",
		borderRadius: "8px",
		bgcolor:
			theme.palette.mode == "dark"
				? theme.palette.secondary.dark
				: theme.palette.secondary.light,
		"& .MuiFilledInput-root": {
			backgroundColor: "transparent",
		},
		"& .Mui-disabled": {
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.background.paper
					: theme.palette.secondary.dark,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.darker
					: theme.palette.secondary.light,
		},
		"& .MuiInputLabel-filled": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.secondary.darker,
		},
		"& .MuiFilledInput-input": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.white.main
					: theme.palette.secondary.dark,
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor: theme.palette.colors.gray.light,
		},
	},
});

export default styles;
